export default __webpack_public_path__ + "assets/ogg/499a45e22c32d5b097d5ecae52f9eac9.ogg";